const CURRENCY_SYMBOLS = {
  AED: "د.إ",
  AUD: "AU$",
  CAD: "CA$",
  CHF: "Fr",
  CNY: "CN¥",
  DKK: "kr",
  EGP: "EG£",
  EUR: "€",
  GBP: "£",
  ILS: "₪",
  INR: "₹",
  JPY: "J¥",
  KRW: "₩",
  MXN: "MX$",
  MYR: "RM",
  PEN: "S/.",
  PKR: "Rs",
  PLN: "zł",
  QAR: "﷼",
  SAR: "﷼",
  SEK: "kr",
  SGD: "S$",
  THB: "฿",
  USD: "US$",
};

const ORDER_STATUS = {
  ALL: "All Orders",
  PENDING: "Pending",
  PAID: "Paid",
  PARTIALLY_PAID: "Partially paid",
  VOIDED: "Voided",
  REFUNDED: "Refunded",
  PARTIALLY_REFUNDED: "Partially refunded",
  AUTHORIZED: "Authorized",
};
const createAccount = () =>
  new Vue({
    data: () => {
      return {
        urlList: {
          profile: "api/v1/profile",
          coupon: "api/v1/discount/coupons",
          order: "web.CustomerService/QueryCustomerOrders",
          orderLine: "web.CustomerService/GetCustomerOrderLines",
        },
        pageNation: {
          page: 1,
          size: 30,
        },
        userInfo: {},
        couponData: {},
        wishlist: [],
        historyList: [],
        orderList: [],
        sectionId: "account-dashboard",
        mySwiperReview: null,
        mySwiperWishlist: null,
        activeIndex: 0,
        status: "",
        showAllLineItems: false,
        adapter: new StorageAdapter(),
        shopify: new ShopifyRelatedV2(),
        productAdapter: new ProductApi(),
        localKey: "cartItems",
        showModifyInfo: false, // 显示修改用户信息弹窗
        errors: {},
        modifyInfo: {
          firstName: "",
          lastName: "",
          password: "",
        },
        touched: {
          password: false,
          confirmPassword: false,
          firstName: false,
          lastName: false,
        },
        confirmPassword: "",
        showPassword: false,
        showConfirmPassword: false,
        passwordTimer: null,
        confirmPasswordTimer: null,
      };
    },
    created() {
      this.init();
    },
    computed: {
      hasErrors() {
        return Object.keys(this.errors)?.length > 0;
      },
    },
    mounted() {
      this.setSlides();
      window.addEventListener("resize", this.setSlides);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.setSlides);
    },
    methods: {
      // 获取用户信息
      getUser() {
        fetchRequest(this.urlList.profile, "GET").then((response) => {
          let userInfo = {};
          if (!response.error) {
            const loginFlag = true;
            userInfo = { loginFlag, ...response.data };
            document.cookie = `userInfo=${JSON.stringify(userInfo)}; path=/`;
            this.userInfo = response.data;
            this.modifyInfo.firstName = response.data.first_name;
            this.modifyInfo.lastName = response.data.last_name;
          }
        });
      },
      // 获取用户优惠券
      getCoupon() {
        const params = {
          type: 0,
          page: 1,
          rows: 50,
        };
        fetchRequest(`${this.urlList.coupon}`, "GET", params).then(
          (response) => {
            if (!response.error) {
              let availableCount = 0;
              let usedCount = 0;
              let expiredCount = 0;
              let invalidCount = 0;
              for (let item of response.data) {
                switch (item.state) {
                  case 10:
                    availableCount++;
                    break;
                  case 80:
                    usedCount++;
                    break;
                  case 60:
                    expiredCount++;
                    break;
                  case 70:
                    invalidCount++;
                    break;
                }
              }
              this.couponData = {
                availableCount,
                usedCount,
                expiredCount,
                invalidCount,
              };
            }
          }
        );
      },
      // 获取心愿单
      getWishList() {
        const productApi = new ProductApi();
        const params = {
          ...this.pageNation,
          sort: 3,
        };
        productApi.getWish(params).then((response) => {
          if (response) {
            this.wishlist = response;
          }
        });
      },
      // 获取浏览记录
      async getRecentlyViewed() {
        const params = {
          pageSize: {
            ...this.pageNation,
          },
        };
        const response = await this.productAdapter.getHistory(params);
        if (response) {
          this.historyList = response.items;
        }
      },

      // 获取用户订单
      getOrder() {
        const params = {
          pageSize: {
            page: 1,
            size: 10,
          },
        };
        if (this.status) params.financialStatus = this.status;
        fetchConnect(this.urlList.order, "POST", params).then((response) => {
          if (!response.error) {
            this.orderList = response.data.items;
          }
        });
      },
      logout() {
        theme.logout();
        window.location.href = "/";
      },
      init() {
        this.getUser();
        this.getCoupon();
        this.getWishList();
        this.getRecentlyViewed();
        this.getOrder();
      },
      setSlides() {
        this.$nextTick(() => {
          this.mySwiperReview = new Swiper(".swiper-container-wish", {
            slidesPerView: 8,
            spaceBetween: 15,
            navigation: {
              nextEl: ".wish-next",
              prevEl: ".wish-prev",
            },
            breakpoints: {
              1200: {
                slidesPerView: 8,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
            },
          });
        });

        this.$nextTick(() => {
          this.mySwiperReview = new Swiper(".swiper-container-view", {
            slidesPerView: 8,
            spaceBetween: 15,
            navigation: {
              nextEl: ".view-next",
              prevEl: ".view-prev",
            },
            breakpoints: {
              1200: {
                slidesPerView: 8,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
            },
          });
        });
      },
      // 返回产品url
      productUrl(item) {
        return `/products/${item?.handle}`;
      },
      // 获取不同类型的id
      getIdStr(name, id) {
        return `${name}-${this.sectionId}-${id}`;
      },

      formatPrice(item) {
        if (item.maxPrice || item.minPrice) {
          if (item.maxPrice == item.minPrice) {
            return `${theme.formatPrice(
              theme.convertCurrency(item.maxPrice, "usdToSet")
            )}`;
          } else {
            return `${theme.formatPrice(
              theme.convertCurrency(item.minPrice, "usdToSet")
            )} - ${theme.formatPrice(
              theme.convertCurrency(item.maxPrice, "usdToSet"),
              false
            )}`;
          }
        }
        if (item.max_price == item.min_price) {
          return `${theme.formatPrice(
            theme.convertCurrency(item.max_price, "usdToSet")
          )}`;
        } else {
          return `${theme.formatPrice(
            theme.convertCurrency(item.min_price, "usdToSet")
          )} - ${theme.formatPrice(
            theme.convertCurrency(item.max_price, "usdToSet"),
            false
          )}`;
        }
      },
      formatOrderPrice(item) {
        const symbol = CURRENCY_SYMBOLS[item?.currencyCode || "USD"];
        return `${symbol}${item?.amount || 0}`;
      },
      viewOrder(order) {
        window.location.href = `/pages/account/my-order?orderId=${order.id}`;
      },
      clickTab(index, key) {
        this.activeIndex = index;
        this.status = index == 0 ? "" : key;
        this.orderList = [];
        this.getOrder();
      },
      // 处理加购数据
      handleData(list) {
        const result = [];
        const typeStr = Object.prototype.toString.call(list);
        if (typeStr === "[object Object]") {
          list = [list];
        }
        for (let item of list) {
          const data = {
            variant_id: item?.variantId,
            quantity: item?.quantity,
            checked: true,
            final_price: item?.originalTotalSet.shopMoney.amount,
            id: item?.variantId,
            url: item?.url,
            product_id: item?.productId,
            product_title: item?.title,
            featured_image: item?.featuredImage,
            variant_options: item?.variant?.selectedOptions,
            weight: item?.variant?.weight,
          };
          result.push(data);
        }
        return result;
      },
      showSuccessMessage() {
        const message = document.getElementById("promptMessage"); //添加成功
        message?.classList.remove("hidden");
        message?.classList.add("show");
        var timer = setTimeout(() => {
          clearTimeout(timer);
          message?.classList.remove("show");
          message?.classList.add("hidden");
        }, 2000);
      },
      async addToCartRequest(list) {
        const items = await this.adapter.create({
          key: this.localKey,
          value: list,
        });
        if (items) {
          this.showSuccessMessage();
          this.selectedItems = [];
          this.selectAll = false;
        }

        if (items && cartPop) {
          cartPop.cartList = items;
          cartPop.shopifyCartData = await this.shopify.create(items);
          theme.reportAddToCart(items);
          cartPop.handleDataList();
        }
      },
      async addOrderToCart(orderId) {
        let lineItems = [];
        const response = await fetchConnect(this.urlList.orderLine, "POST", {
          id: orderId || this.orderId,
          pageSize: {
            page: 1,
            size: 250,
          },
        });

        if (!response.error) {
          lineItems = response.data?.items;
        }
        lineItems = this.handleData(lineItems);
        this.addToCartRequest(lineItems);
      },
      handleModifyBtn() {
        this.showModifyInfo = !this.showModifyInfo;
        if (document.body) {
          document.body.classList.toggle("overflow-hidden");
        }
      },
      /**
       * 切换密码可见
       * @param {string} type - 'password' 或 'confirmPassword'
       */
      togglePasswordVisibility(type) {
        if (type === "password") {
          if (this.passwordTimer) {
            clearTimeout(this.passwordTimer);
            this.passwordTimer = null;
          }

          this.showPassword = !this.showPassword;

          if (this.showPassword) {
            this.passwordTimer = setTimeout(() => {
              this.showPassword = false;
              this.passwordTimer = null;
            }, 1000);
          }
        } else if (type === "confirmPassword") {
          if (this.confirmPasswordTimer) {
            clearTimeout(this.confirmPasswordTimer);
            this.confirmPasswordTimer = null;
          }

          this.showConfirmPassword = !this.showConfirmPassword;

          if (this.showConfirmPassword) {
            this.confirmPasswordTimer = setTimeout(() => {
              this.showConfirmPassword = false;
              this.confirmPasswordTimer = null;
            }, 1000);
          }
        }
      },
      /**
       * 标记字段是否被触摸
       * @param {string} field - 字段名
       */
      markAsTouched(field) {
        this.validateField(field);
        this.touched[field] = true;
      },
      /**
       * 验证单个字段
       * @param {string} field - 字段名称
       */
      validateField(field) {
        // 清除该字段的错误
        if (this.errors[field]) {
          const { [field]: _, ...rest } = this.errors;
          this.errors = rest;
        }

        // 根据字段类型验证
        switch (field) {
          case "password":
            if (this.modifyInfo.password) {
              if (
                this.modifyInfo.password?.length > 40 ||
                this.modifyInfo.password?.length < 5
              ) {
                this.errors.password =
                  "Password enter a password with 5 to 40 characters";
              }
              // 如果确认密码已填写，也验证确认密码
              if (this.touched.confirmPassword && this.confirmPassword) {
                this.validateField("confirmPassword");
              }
            }
            break;

          case "confirmPassword":
            if (this.confirmPassword !== this.modifyInfo.password) {
              this.errors.confirmPassword = "Passwords do not match";
            }
            break;
        }
      },
      /**
       * 验证表单数据
       * @returns {boolean} 验证是否通过
       */
      validateForm() {
        // 清除所有错误
        this.errors = {};

        // 验证所有字段
        this.validateField("password");
        this.validateField("confirmPassword");

        // 标记所有字段为已触摸
        Object.keys(this.touched).forEach((field) => {
          this.touched[field] = true;
        });

        return !this.hasErrors;
      },
      async fetchModifyInfo() {
        if (!this.validateForm()) {
          return;
        }
        const query = `mutation customerUpdate(
          $customer: CustomerUpdateInput!
          $customerAccessToken: String!
        ) {
          customerUpdate(
            customer: $customer
            customerAccessToken: $customerAccessToken
          ) {
            customer {
              id
              email
              phone
              lastName
              firstName
              displayName
            }
            customerUserErrors {
              code
              field
              message
            }
            userErrors {
              field
              message
            }
          }
        }`;

        const { customerUpdate } = await fetchGraphQL(query, {
          customer: {
            ...this.modifyInfo,
          },
          customerAccessToken: JSON.parse(theme.getCookies("s_token")),
        });

        if (customerUpdate) {
          this.handleModifyBtn();
          this.showSuccessMessage();
          const customer = customerUpdate.customer;
          this.userInfo.first_name = customer.firstName;
          this.userInfo.last_name = customer.lastName;
          if (this.modifyInfo.password) {
            this.logout();
          }
        }
      },
      handleDate(date) {
        return String(date).replace("T", " ").replace("Z", "");
      },
    },
    template: `
    <div class="content-list" id="account-dashboard">
      <div class="flex gap-5 account-dashboard">
        <div class="bg-white flex justify-content-center">
          <div>
            <div class="font-bold">Hi, {{ userInfo.first_name }} {{ userInfo.last_name }} <span class="registered-tag">Registered</span></div>
            <div class="font-bold">
              <svg
                t="1742005624093"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="14625"
                width="18"
                height="18"
              >
                <path d="M901.557832 195.910948 122.431935 195.910948c-33.127492 0-60.042491 26.900673-60.042491 60.065004l0 509.325078c0 33.221636 26.885324 60.065004 60.042491 60.065004l779.125897 0c33.135678 0 60.051701-26.901697 60.051701-60.065004L961.609533 255.975952C961.609533 222.75227 934.724209 195.910948 901.557832 195.910948zM796.517497 410.939303l-268.550339 155.051355c-4.15667 3.541663-9.485025 5.41636-14.886035 5.328355-5.399987 0.088004-10.726296-1.786693-14.883989-5.328355l-268.551362-155.051355c-10.765181-6.205329-14.497179-19.875676-8.246825-30.706349 6.212492-10.742668 19.897166-14.488992 30.727839-8.225335l260.954337 150.661372 260.956384-150.661372c10.829649-6.263657 24.514323-2.517333 30.720675 8.225335C811.021839 391.063627 807.275515 404.733974 796.517497 410.939303z" fill="#333333" p-id="14626"></path>
              </svg>
              <span :title="userInfo.email">{{ userInfo.email }}</span>
            </div>
            <div class="font-bold">
              <span class="cursor-pointer" @click="handleModifyBtn">
                <svg 
                  t="1750411583221" 
                  class="icon" 
                  viewBox="0 0 1024 1024" 
                  version="1.1" 
                  xmlns="http://www.w3.org/2000/svg" 
                  p-id="5370" 
                  width="18" 
                  height="18"
                >
                  <path d="M0 778.24V972.8h194.56l563.2-568.32L563.2 209.92 0 778.24zM906.24 256c20.48-20.48 20.48-51.2 0-71.68L788.48 66.56c-20.48-20.48-51.2-20.48-71.68 0l-92.16 92.16L819.2 353.28 906.24 256zM460.8 870.4L358.4 972.8H1024V870.4H460.8z" fill="#333333" p-id="5371"></path>
                </svg>
                <span class="underline">Modify Information >></span>
              </span>
            </div>
            <div class="font-bold">
              <span @click="logout" class="cursor-pointer">
                <svg
                  t="1741945152453"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="12049"
                  width="18"
                  height="18"
                >
                  <path d="M533.333333 64a21.333333 21.333333 0 0 1 21.333334 21.333333v42.666667a21.333333 21.333333 0 0 1-21.333334 21.333333H170.666667v725.333334h362.666666a21.333333 21.333333 0 0 1 21.333334 21.333333v42.666667a21.333333 21.333333 0 0 1-21.333334 21.333333H170.666667a85.333333 85.333333 0 0 1-85.226667-81.066667L85.333333 874.666667V149.333333a85.333333 85.333333 0 0 1 81.066667-85.226666L170.666667 64h362.666666z m194.581334 219.584l183.168 183.168a64 64 0 0 1 2.88 87.424l-2.88 3.072-183.168 183.168a21.333333 21.333333 0 0 1-30.165334 0l-30.165333-30.165333a21.333333 21.333333 0 0 1 0-30.165334L792.96 554.666667H362.666667a21.333333 21.333333 0 0 1-21.333334-21.333334v-42.666666a21.333333 21.333333 0 0 1 21.333334-21.333334h430.293333l-125.376-125.418666a21.333333 21.333333 0 0 1 0-30.165334l30.165333-30.165333a21.333333 21.333333 0 0 1 30.165334 0z" fill="#ed5749" p-id="12050"></path>
                </svg>
                <span class="underline">Logout</span>
                
              </span>
            </div>
          </div>
        </div>
        <div class="bg-white mobile-hidden">
          <a class="flex justify-space-between account-title" href="/pages/account/my-coupon">
            <span>My Coupons</span>
            <svg
              t="1741947165085"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13217"
              width="16"
              height="16"
            >
              <path d="M779.180132 473.232045 322.354755 16.406668c-21.413706-21.413706-56.121182-21.413706-77.534887 0-21.413706 21.413706-21.413706 56.122205 0 77.534887l418.057421 418.057421L244.819868 930.057421c-21.413706 21.413706-21.413706 56.122205 0 77.534887 10.706853 10.706853 24.759917 16.059767 38.767955 16.059767s28.061103-5.353938 38.767955-16.059767L779.180132 550.767955C800.593837 529.35425 800.593837 494.64575 779.180132 473.232045z" p-id="13218" fill="#333333"></path>
            </svg>
          </a>
          <div class="text-center my-coupons">
            <img class="cursor-pointer" src="https://www.gooddiy.com/cdn/shop/t/82/assets/my_coupons.png?v=169490944204121656361740058834" alt="">
            <div class="coupon-content text-center flex justify-content-center">
              <div class="font-bold">
                <p>Available</p>
                <p class="active-color available-count">{{ couponData.availableCount}}</p>
              </div>
              <div class="gap">|</div>
              <div class="font-bold">
                <p>Expired</p>
                <p class="active-color expired-count">{{ couponData.expiredCount }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white mobile-hidden">
          <a class="flex justify-space-between align-items-center account-title" href="/pages/account/address-management">
            <span>Address Management</span>
            <svg
              t="1741947165085"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13217"
              width="16"
              height="16"
            >
              <path d="M779.180132 473.232045 322.354755 16.406668c-21.413706-21.413706-56.121182-21.413706-77.534887 0-21.413706 21.413706-21.413706 56.122205 0 77.534887l418.057421 418.057421L244.819868 930.057421c-21.413706 21.413706-21.413706 56.122205 0 77.534887 10.706853 10.706853 24.759917 16.059767 38.767955 16.059767s28.061103-5.353938 38.767955-16.059767L779.180132 550.767955C800.593837 529.35425 800.593837 494.64575 779.180132 473.232045z" p-id="13218" fill="#333333"></path>
            </svg>
          </a>
          <div class="text-center address-management">
            <img class="cursor-pointer" src="https://www.gooddiy.com/cdn/shop/t/82/assets/address_management.png?v=121902968970814664521741946607
            " alt="">
          </div>
        </div>
        <div class="manager bg-white">
          <div class="account-title">Your Account Manager</div>
          <div class="flex gap-10">
            <img src="https://www.gooddiy.com/cdn/shop/t/82/assets/account_manager.png?v=169321142222858341911741946350">
            <div class="manager-content">
              <div class="font-bold margin-t-12">Name: Amelia</div>
              <div class="font-bold font-size-13 margin-t-12">Whatsapp:</div>
              <a
                class="underline font-bold font-size-13"
                target="_blank"
                :href="window.whatsappUrl"
                >13043650678</a
              >
              <div class="font-bold margin-t-12">Email:</div>
              <a class="underline font-bold" target="_blank" href="mailto://help@gooddiy.com"
                >help@gooddiy.com</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white my-orders">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>My Orders</div>
          <a href="/pages/account/my-order" class="underline">View All ></a>
        </div>
        <div class="flex order-tab cursor-pointer">
          <div class="flex-1" :class="activeIndex == index ? 'active' : ''" v-for="(value, key, index) in ORDER_STATUS" @click="clickTab(index, key)">{{ value }}</div>
        </div>
        <div class="table" v-if="orderList?.length>0">
          <div class="table-row table-header">
            <div class="table-cell">Order</div>
            <div class="table-cell">Created Date</div>
            <div class="table-cell">cancellation Date</div>
            <div class="table-cell">Total</div>
            <div class="table-cell">Payment status</div>
            <div class="table-cell">Fulfillment status</div>
            <div class="table-cell">operation</div>
          </div>
          <div class="table-row font-size-14" v-for="(order, index) in orderList" v-show="index < 3 || showAllLineItems">
            <div class="table-cell">
              <div>{{ order.name }}</div>
              <a href="javascript:void(0)" @click="viewOrder(order)" class="font-size-13 active-color">View Order</a>
            </div>
            <div class="table-cell flex justify-content-center align-items-center">{{ handleDate(order.createdAt) }}</div>
            <div class="table-cell flex justify-content-center align-items-center">{{ order.cancelledAt == '0001-01-01T00:00:00Z' ? '' : handleDate(order.cancelledAt) }}</div>
            <div class="table-cell flex justify-content-center align-items-center">{{ formatOrderPrice(order.totalPriceSet.shopMoney) }}</div>
            <div class="table-cell flex justify-content-center align-items-center text-lowercase">
              {{ order.displayFinancialStatus }}
            </div>
            <div class="table-cell flex justify-content-center align-items-center text-lowercase">
              {{ order.displayFulfillmentStatus }}
            </div>
            <div class="table-cell flex justify-content-center align-items-center">
              <span class="re-order-btn cursor-pointer" @click="addOrderToCart(order.id)">Re-order</span>
            </div>
          </div>
          <div class="flex justify-content-center" v-if="orderList?.length > 3 && !showAllLineItems" @click="showAllLineItems = true">
            <div class="order-more-btn">
              <span class="icon-caret">
                <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div class="flex justify-content-center align-items-center no-data" v-else>
          <div>
            <img src="https://assets.gooddiy.com/image/no-data.png">
          </div>
        </div>
      </div>
      <div class="bg-white my-wishlist relative">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>My Wishlist</div>
          <a href="/pages/account/my-wishlist" class="underline">View All ></a>
        </div>
        <div class="info-box" v-show="wishlist?.length>0">
          <div class="swiper-container-wish">
            <div class="swiper-wrapper">
              <div class="bg-white swiper-slide" v-for="item in wishlist">
                <div class="card-wrapper wbproduct-container product-card-wrapper center">
                  <div class="card card--standard card--media">
                    <div class="card__inner  color-scheme-abe3bc68-5409-41dd-abcf-8f9ac474947a gradient wbimgblock  ratio">
                      <div class="card__media ">
                        <div class="product__media-item">
                          <a
                            :href="productUrl(item)"
                            :title="item.title"
                            class="media media--transparent media-- media--hover-effect"
                          >
                            <img
                              :src="item.featured_image + '?width=370'"
                              :alt="item.title"
                              class="motion-reduce"
                              loading="lazy"
                            >
                          </a>
                        </div>
                      </div>

                      <modal-opener data-modal="#QuickAdd" class="float-add-cart">
                        <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                          <div>
                            <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                          </div>
                          <div class="loading-overlay__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </modal-opener>
                    </div>
                    <div class="relative">
                      <wb-card-variant>
                        <div class="wbproductdes card__content">
                          <product-info
                            :id="getIdStr('ProductInfo',item.id)"
                            data-layout="card"
                            :data-url="productUrl(item)"
                          >
                            <div class="card__information">
                              <h3
                                class="cardhide_toggle card__heading overflow_text h5"
                                id="title-template--18120210415846__main-8944177905894"
                              >
                                <a
                                  :href="productUrl(item)"
                                  :id="getIdStr('CardLink',item.id)"
                                  class="full-unstyled-link"
                                  target="_blank"
                                >
                                  {{ item.title}}
                                </a>
                              </h3>
                              <div class="card-information">
                                <div
                                  class="no-js-hidden wbhprice"
                                  :id="getIdStr('price',item.id)"
                                  role="status"
                                >
                                  <div class="card_product_Price">
                                    <span class="card_sale_price notranslate">
                                      {{ formatPrice(item) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </product-info>
                        </div>
                      </wb-card-variant>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-prev wish-prev"><img src="https://assets.gooddiy.com/image/arrow_up.png" class="pagenation-arrow arrow-left"></div>
          <div class="swiper-next wish-next"><img src="https://assets.gooddiy.com/image/arrow_up.png" class="pagenation-arrow arrow-right"></div>
        </div>
        <div class="empty" v-show="wishlist?.length==0">
          <img src="https://www.gooddiy.com/cdn/shop/t/75/assets/wish_empty.png?v=118747834712193806541724391399" alt="">
          <div>You have not saved anything recently</div>
        </div>
      </div>
      <div class="bg-white recent-view relative">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>Recently Viewed</div>
          <a href="/pages/account/recently-viewed" class="underline">View All ></a>
        </div>
        <div class="info-box" v-show="historyList?.length>0">
          <div class="swiper-container-view">
            <div class="swiper-wrapper">
              <div class="bg-white swiper-slide" v-for="item in historyList">
                <div class="card-wrapper wbproduct-container product-card-wrapper center">
                  <div class="card card--standard card--media">
                    <div class="card__inner  color-scheme-abe3bc68-5409-41dd-abcf-8f9ac474947a gradient wbimgblock  ratio">
                      <div class="card__media ">
                        <div class="product__media-item">
                          <a
                            :href="productUrl(item)"
                            :title="item.title"
                            class="media media--transparent media-- media--hover-effect"
                          >
                            <img
                              :src="item.featuredImage + '?width=370'"
                              :alt="item.title"
                              class="motion-reduce"
                              loading="lazy"
                            >
                          </a>
                        </div>
                      </div>

                      <modal-opener data-modal="#QuickAdd" class="float-add-cart">
                        <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                          <div>
                            <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                          </div>
                          <div class="loading-overlay__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </modal-opener>
                    </div>
                    <div class="relative">
                      <wb-card-variant>
                        <div class="wbproductdes card__content">
                          <product-info
                            :id="getIdStr('ProductInfo',item.id)"
                            data-layout="card"
                            :data-url="productUrl(item)"
                          >
                            <div class="card__information">
                              <h3
                                class="cardhide_toggle card__heading overflow_text h5"
                                id="title-template--18120210415846__main-8944177905894"
                              >
                                <a
                                  :href="productUrl(item)"
                                  :id="getIdStr('CardLink',item.id)"
                                  class="full-unstyled-link"
                                  target="_blank"
                                >
                                  {{ item.title}}
                                </a>
                              </h3>
                              <div class="card-information">
                                <div
                                  class="no-js-hidden wbhprice"
                                  :id="getIdStr('price',item.id)"
                                  role="status"
                                >
                                  <div class="card_product_Price">
                                    <span class="card_sale_price notranslate">
                                      {{ formatPrice(item) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </product-info>
                        </div>
                      </wb-card-variant>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-prev view-prev"><img src="https://assets.gooddiy.com/image/arrow_up.png" class="pagenation-arrow arrow-left"></div>
          <div class="swiper-next view-next"><img src="https://assets.gooddiy.com/image/arrow_up.png" class="pagenation-arrow arrow-right"></div>
        </div>
        <div class="empty" v-show="historyList?.length==0">No Data</div>
      </div>
      <div v-show="showModifyInfo" class="modify-info-modal">
        <div class="modal-content">
          <div class="modal-header flex justify-space-between">
            <span>Modify Information</span>
            <span class="cursor-pointer" @click="handleModifyBtn">✕</span>
          </div>
          <div class="modal-main">
            <div class="form-group relative">
              <input 
                type="email"
                v-model="userInfo.email"
                disabled
              >
            </div>
            <div class="form-group relative">
              <input 
                type="text"
                autocomplete="off"
                v-model="modifyInfo.firstName"
                placeholder="Enter your first name"
              >
            </div>
            <div class="form-group relative">
              <input 
                type="text"
                autocomplete="off"
                v-model="modifyInfo.lastName"
                placeholder="Enter your last name"
              >
            </div>
            <div class="form-group relative">
              <input 
                :type="showPassword ? 'text' : 'password'" 
                id="password" 
                autocomplete="off"
                v-model="modifyInfo.password"
                @input="markAsTouched('password')"
                :class="{'error-input': errors.password}"
                placeholder="Enter your password"
              >
              <div 
                class="toggle-password-btn" 
                @click="togglePasswordVisibility('password')"
              >
                <svg v-if="showPassword" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </div>
              <div v-if="errors?.password" class="error-message absolute">{{ errors?.password }}</div>
            </div>
            <div class="form-group relative">
              <input 
                :type="showConfirmPassword ? 'text' : 'password'" 
                id="confirm_password" 
                autocomplete="off"
                v-model="confirmPassword"
                @input="markAsTouched('confirmPassword')"
                :class="{'error-input': errors.confirmPassword}"
                placeholder="Confirm password"
              >
              <div 
                class="toggle-password-btn" 
                @click="togglePasswordVisibility('confirmPassword')"
              >
                <svg v-if="showConfirmPassword" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </div>
              <div v-if="errors.confirmPassword" class="error-message absolute">{{ errors?.confirmPassword }}</div>
            </div>
            <div class="form-actions flex justify-content-end gap-10">
              <button 
                class="confirm-button modal-button" 
                @click.prevent="fetchModifyInfo"
              >
                <span>Confirm</span>
              </button>
              <button 
                class="modal-button" 
                @click.prevent="handleModifyBtn"
              >
                <span>Cancel</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  `,
  });

let account = null;
// account.$mount("#account-dashboard");
